<template>
  <div style="text-align: left;">
    <slot />
    <div class="mt-3 pa-3" style="border: 1px solid #C48AF055; border-radius: 8px; background-color: #C48AF022;">
      <div class="font-weight-medium" style="color: #C48AF0;">
        {{ count }} request{{ count > 1 ? 's' : '' }} will be set to EMERGENCY ONLY
      </div>
      <div class="text-caption">
        These requests are dispatched at LOW priority only when they arrive as emergency, and are excluded during
        routine dispatch. They also need the radiologist's global Emergency toggle to be enabled.
      </div>
      <div class="text-caption orange--text mt-1" v-if="warning">{{ warning }}</div>
    </div>
    <div class="mt-3 emergency-affected-list">
      <div class="emergency-affected-label">Affected requests</div>
      <ul>
        <li v-for="request of requests" :key="request.modality">
          <strong>{{ request.modality }}</strong> : {{ request.requestTypes.join(', ') }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmergencyOnlySummary",
  props: {
    count: {
      type: Number,
      default: 0,
    },
    requests: {
      //[{modality, requestTypes}] as grouped by groupRequestsByModality
      type: Array,
      default: () => [],
    },
    warning: {
      //extra warning to show under the explanation, when the settings make these requests undispatchable
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
/* the affected requests panel, as in the pickup rules design */
.emergency-affected-list {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 14px;
  max-height: 180px;
  overflow: auto;
  color: #E53935;
}

.emergency-affected-list .emergency-affected-label {
  font-size: 12px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #6F7890;
  margin-bottom: 6px;
}

.emergency-affected-list ul {
  margin: 0;
  padding-left: 18px;
}

.emergency-affected-list li {
  margin-bottom: 4px;
  line-height: 1.5;
}
</style>
